import { useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';

QrScanner.WORKER_PATH = '/assets/js/qr-scanner-worker.min.js';

export const useQrScanner = (cb: (res: string) => void) => {
  const [qrScanner, setQrScanner] = useState<QrScanner | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isHasCamera, setIsHasCamera] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);

  const qrScannerRef = useRef<HTMLVideoElement>(null);

  const handleCheckCamera = async () => {
    const hasCamera = await QrScanner.hasCamera();

    setIsHasCamera(hasCamera);
    setIsLoading(false);
  };

  const handleOpenCamera = async () => {
    const scanner = new QrScanner(qrScannerRef.current, (res) => {
      cb(res);
    });
    await scanner.start();

    setIsCameraOpen(true);
    setQrScanner(scanner);
  };

  const handleStopCamera = () => {
    if (qrScanner) {
      qrScanner.stop();
      qrScanner.destroy();
    }

    setIsCameraOpen(false);
    setQrScanner(null);
  };

  useEffect(() => {
    handleCheckCamera();
    return () => {
      handleStopCamera();
    };
  }, []);

  return {
    isLoading,
    isHasCamera,
    isCameraOpen,
    handleOpenCamera,
    handleStopCamera,
    ref: qrScannerRef,
  };
};
